
import Event = createjs.Event;

export class Poker2BanditEvent extends Event {
    public static START_SLOTMACHINE: string = "startBandit";
    public static HIDE_NOMONEY_DIALOG: string = "hidePoker2NoMoneyDialog";

    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
